
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-stopped",
      function () {
        return require("private-next-pages/service-stopped.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-stopped"])
      });
    }
  